import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Task } from '@repo/shared';

import { useModels } from '@/api/generated';
import Combobox, { type ComboboxProps } from '@/components/ui/combobox';
import { Skeleton } from '@/components/ui/skeleton';

interface ModelComboboxProps extends Omit<ComboboxProps<false>, 'options'> {
  task?: Task;
}

const ModelCombobox: FC<ModelComboboxProps> = ({ task, ...props }) => {
  const { t } = useTranslation();

  const { data: models, isLoading } = useModels({ task });
  const options = useMemo(
    () =>
      (models ?? []).map((model) => ({
        label: model.name,
        value: model.id,
      })),
    [models]
  );

  if (isLoading) {
    return <Skeleton className='h-10 w-full' />;
  }

  return (
    <Combobox
      {...props}
      placeholder={t('components.modelCombobox.placeholder')}
      options={options}
    />
  );
};

export default ModelCombobox;
